export const FIVE_ROW_HEIGHT = '225px';

export const TIERED_ACCOUNTS_PAGE_SIZE = 25;

export const MAX_NUMBER_OF_CHILD_ACCOUNTS = 150;
